import React from 'react'
import { Link } from 'react-router-dom'


const menu1 = [
  {
    label: ">   About us",
    nav: "/about-us"
  },
  {
    label: ">   Join",
    nav: "/about-us"
  },
  {
    label: ">   Events",
    nav: "/about-us"
  },
  {
    label: ">   Stories",
    nav: "/about-us"
  },
  {
    label: ">   Committee",
    nav: "/about-us"
  },
]
const menu2 = [
  {
    label: ">   Gallery",
    nav: "/about-us"
  },
  {
    label: ">   Contact Us",
    nav: "/about-us"
  },
  {
    label: ">   Privacy Policy",
    nav: "/about-us"
  },
  {
    label: ">   FAQ",
    nav: "/about-us"
  },
  {
    label: ">   License",
    nav: "/about-us"
  },
]
function Footer() {
  return (
    <>
      <div id="contact-us" className='footer-section lg:pt-[150px] pt-[140px] relative'>
        <div>
          <div className='flex lg:p-[60px] p-[20px] justify-between items-start lg:gap-[142px] gap-[30px] lg:flex-row flex-col'>
            <div className='max-w-[402px] flex lg:justify-start justify-center w-full'>
              <Link to="/">
                <img src="/assets/nav/logo.png" className='lg:h-[132px] h-[84px]' alt="" />
              </Link>
              {/* <p className="font-[400] font-manrope text-[16px] leading-[26px] text-[#BABBC5] pt-[30px]">VANS, we ignite curiosity, foster creativity, and
                inspire innovation. As a leading institution of higher
                learning, we are dedicated to providing an exceptional
                education that empowers our students to excel in their
                chosen fields and become global citizens of impact.</p> */}
            </div>
            <div className="w-full grid lg:grid-cols-2 grid-cols-2 lg:gap-0 gap-[30px]">
              <div>
                <h6 className="font-[500] font-manrope lg:text-[24px] text-[20px] lg:leading-[33px] leading-[26px] text-[#FFFFFF] lg:pb-[40px] pb-[20px]">Contact Us</h6>
                <div className='font-[400] font-manrope lg:text-[16px] text-[12px] lg:leading-[26px] leading-[18px] text-[#BABBC5] flex flex-col lg:gap-[18px] gap-[12px]'>
                  {/* {menu1?.map((e, i) => {
                    return (
                      <Link to={e?.nav} key={i} className='font-[400] font-manrope lg:text-[16px] text-[12px] lg:leading-[26px] leading-[18px] text-[#BABBC5]'>
                        {e?.label}
                      </Link>
                    )
                  })} */}
                  Address -  Punjabi Bagh, Delhi, Pin-code: 110026<br />
                  Contact Number - +91-9266946673 <br />
                  E-Mail - vdjsalumninetwork@gmail.com

                </div>
              </div>
              {/* <div>
                <h6 className="font-[500] font-manrope lg:text-[24px] text-[20px] lg:leading-[33px] leading-[26px] text-[#FFFFFF] lg:pb-[40px] pb-[20px]">Quick Links</h6>
                <div className='flex flex-col lg:gap-[18px] gap-[12px]'>
                  {menu2?.map((e, i) => {
                    return (
                      <Link to={e?.nav} key={i} className='font-[400] font-manrope lg:text-[16px] text-[12px] lg:leading-[26px] leading-[18px] text-[#BABBC5]'>
                        {e?.label}
                      </Link>
                    )
                  })}
                </div>
              </div> */}
              <div>
                <h6 className="font-[500] font-manrope lg:text-[24px] text-[20px] lg:leading-[33px] leading-[26px] text-[#FFFFFF] lg:pb-[40px] pb-[20px]">Follow us</h6>
                <div className='flex gap-[20px] items-center'>
                  <Link to="https://www.facebook.com/share/1ALPJcnzja/" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/footer/facebook.svg" alt="" />
                  </Link>
                  <Link to="https://www.instagram.com/vdjsalumninetwork?igsh=YmJzdXlxdGdleHJl" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/footer/instagram.svg" alt="" />
                  </Link>
                  {/* <Link target="_blank" rel="noopener noreferrer">
                      <img src="/assets/footer/x.svg" alt="" />
                    </Link> */}
                  <Link to="https://www.linkedin.com/company/vdjs-alumni-network/" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/footer/linkedin.svg" alt="" />
                  </Link>
                  <Link to="https://chat.whatsapp.com/HH7NkZyiWrhLqZEUHU0Xyw" target="_blank" rel="noopener noreferrer">
                    <img src="/assets/footer/whatsapp.svg" className="w-7 h-7" alt="WhatsApp" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
          <div className='border-t lg:mx-[60px] mx-[20px] border-[#696D82] py-[26px]'>
            <p className="text-[#FFFFFFCC] font-[400] font-manrope text-[15px] leading-[25px] text-center">© VANS  2025 | Developed by 
               <Link to="https://strixdigital.in/" target="_blank" className="hover:underline text-white">
                 {" "}Strix Digital
          </Link>
            </p>
          </div>
        </div>
      </div>
    </>
  )
}

export default Footer
